<template>
    <div class="components-container">
        <div class="filter-container">
            <el-input v-model="queryForm.stuCode" @keyup.enter.native="handleFilter" style="width: 150px" placeholder="学号 / 姓名" clearable></el-input>
            <el-input v-model="queryForm.className" @keyup.enter.native="handleFilter" style="width: 150px" placeholder="行政班名称" clearable></el-input>
            <el-select v-model="queryForm.stuState" placeholder="状态" style="width:150px;">
                <el-option v-for="item in comboData.stuState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button v-if="operateButtonVisible" @click="showGraduateRequire" type="primary"><i class="el-icon-setting"></i>&nbsp;毕业要求</el-button>
            <el-button v-if="operateButtonVisible" @click="initStuRec" type="primary"><i class="el-icon-document-add"></i>&nbsp;生成名单</el-button>
            <el-button v-if="operateButtonVisible && graduateParam.standardType" @click="showAddStuList" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
            <el-button v-if="operateButtonVisible && graduateParam.standardType" @click="submitRec" type="warning"><i class="el-icon-document-checked"></i>&nbsp;提交</el-button>
            <el-button v-if="operateButtonVisible" @click="cantGraduateStu" type="gray"><i class="el-icon-search"></i>&nbsp;不可毕业学生</el-button>
            <el-button @click="exportStuList" type="primary"><i class="el-icon-download"></i>&nbsp;导出</el-button>
        </div>

        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学号" prop="stuCode" align="center" width="130px"></el-table-column>
            <el-table-column label="姓名" prop="stuName" align="center" width="130px"></el-table-column>
            <el-table-column label="行政班名称" prop="className" align="center" min-width="20%"></el-table-column>
            <el-table-column v-if="subjectFieldVisible" label="科目总数" prop="totalSubjectNum" align="center" width="100px" key="1"></el-table-column>
            <el-table-column v-if="subjectFieldVisible" label="合格科目数" prop="subjectNum" align="center" width="100px" key="2"></el-table-column>
            <el-table-column v-if="subjectFieldVisible" label="合格率" prop="subjectRatio" align="center" width="100px" key="3"></el-table-column>
            <el-table-column v-if="creditFieldVisible" label="毕业要求学分" prop="totalCredit" align="center" width="110px" key="4"></el-table-column>
            <el-table-column v-if="creditFieldVisible" label="获得学分" prop="credit" align="center" width="110px" key="5"></el-table-column>
            <el-table-column v-if="creditFieldVisible" label="得分率" prop="creditRatio" align="center" width="100px" key="6"></el-table-column>
            <el-table-column label="状态" prop="stuState" align="center" width="100px"></el-table-column>
            <el-table-column label="备注" prop="statusChange" align="center" width="200px"></el-table-column>
            <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                    <el-button size="small" @click="showScoreList(scope.row);" type="primary">
                        <i class="el-icon-tickets"></i>&nbsp;成绩
                    </el-button>
                    <el-button v-if="operateButtonVisible" size="small" @click="delStuRec(scope.row);" type="danger">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <el-row v-show="auditAreaVisible">
            <el-col :span="24">
                <audit ref="audit" :itemCode="graduateParam.auditParam" :relatedCode="graduateParam.mainCode"
                    :auditLevel="graduateParam.auditLevel" @auditCallback="auditCallback"></audit>
            </el-col>
        </el-row>

        <el-dialog title="毕业学生名单生成" :visible.sync="dialogVisible" v-if="dialogVisible" width="380px" top="300px" append-to-body>
            <div style="height:250px;">
                <el-form label-width="120px" label-position="left" width="100%">
                    <el-form-item label="学年">{{ graduateParam.year }}</el-form-item>
                    <el-form-item label="毕业标准类型" prop="standardType">
                        <el-radio-group v-model="curdForm.standardType">
                            <el-radio-button v-for="item in comboData.standardType" :key="item.comboValue"
                                :label="item.comboValue">{{ item.comboName }}</el-radio-button>
                        </el-radio-group>
                        <!--
                        <el-select v-model="curdForm.standardType" filterable placeholder="请选择毕业标准类型" style="width:100%">
                            <el-option v-for="item in comboData.standardType" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                        -->
                    </el-form-item>
                    <el-form-item label="毕业标准（%）" prop="standardRatio">
                        <el-input-number v-model="curdForm.standardRatio" controls-position="right" :precision="1"
                            :step="0.1" :max="100" style="width:100%">
                            <i slot="suffix" style="font-weight:bold; margin-right: 5px;">%</i>
                        </el-input-number>
                    </el-form-item>
                </el-form>
                <div style="width:100%; text-align:center; margin:10px 0 10px 0;">
                    <el-button type="success" :loading="formSubmiting" @click="createStuInfo">生 成</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="毕业要求  『 目前仅以总学分作为判断毕业标准 』" :visible.sync="graduateRequireDialogVisible"
            v-if="graduateRequireDialogVisible" width="1200px" top="80px" append-to-body>
            <div style="height:660px;">
                <graduateRequire ref="graduateRequire" :graduateParam="graduateParam">
                </graduateRequire>
            </div>
        </el-dialog>

        <el-dialog title="添加" :visible.sync="addStuDialogVisible" v-if="addStuDialogVisible" width="1100px" top="50px" append-to-body>
            <div style="height:660px;">
                <addStu ref="addStu" :graduateParam="graduateParam" @closeAddStuDialog="closeAddStuDialog">
                </addStu>
            </div>
        </el-dialog>

        <el-dialog title="科目成绩信息" :visible.sync="scoreDialogVisible" v-if="scoreDialogVisible" width="900px" top="150px"
            append-to-body>
            <div style="height:540px;">
                <el-table :data="scoreTableData" v-loading.body="tableLoading" element-loading-text="信息加载中"
                    highlight-current-row border style="width: 100%" height="500" ref="scoreTable">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="学年学期名称" prop="semesterName" align="center" width="200px"></el-table-column>
                    <el-table-column label="课程名称" prop="courseName" align="center" min-width="20%"></el-table-column>
                    <el-table-column label="成绩" prop="score" align="center" width="100px"></el-table-column>
                    <el-table-column label="学分" prop="credit" align="center" width="100px"></el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <el-dialog title="不可毕业学生" :visible.sync="cantGraduateDialogVisible" v-if="cantGraduateDialogVisible"  width="1400px" top="50px" append-to-body>
            <div style="height:700px;">
                <div class="filter-container">
                    <el-input v-model="cantGraduateForm.stuCode" @keyup.enter.native="cantGraduateStu" style="width: 200px" placeholder="学号 / 姓名" clearable></el-input>
                    <el-input v-model="cantGraduateForm.className" @keyup.enter.native="cantGraduateStu" style="width: 200px" placeholder="行政班名称" clearable></el-input>
                    <el-button @click="cantGraduateStu" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
                    <el-button @click="cantGraduateHandleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
                    <el-button @click="cantGraduateExport" type="primary"><i class="el-icon-download"></i>&nbsp;导出</el-button>
                </div>

                <el-table :data="cantGraduateTableData" v-loading.body="tableLoading" element-loading-text="信息加载中"
                    highlight-current-row border style="width: 100%" height="600" ref="cantGraduateTable">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="学号" prop="stuCode" align="center" width="150px"></el-table-column>
                    <el-table-column label="姓名" prop="stuName" align="center" width="150px"></el-table-column>
                    <el-table-column label="行政班名称" prop="className" align="center" min-width="20%"></el-table-column>
                    <el-table-column label="毕业要求学分" prop="totalCredit" align="center" width="110px"></el-table-column>
                    <el-table-column label="获得学分" prop="credit" align="center" width="100px"></el-table-column>
                    <el-table-column label="得分率" prop="creditRatio" align="center" width="100px"></el-table-column>
                    <el-table-column label="状态" prop="stuState" align="center" width="110px"></el-table-column>
                    <el-table-column label="备注" prop="statusChange" align="center" width="100px"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";
    import graduateRequire from 'views/baseInfo/student/graduateRequire.vue';
    import addStu from 'views/baseInfo/student/graduateAddStu.vue';
    import audit from 'views/audit/audit.vue';

    export default {
        props: ['graduateParam'],
        components: {
            graduateRequire,
            addStu,
            audit,
        },
        data() {
            return {
                maskObj: null,
                opreateButtonVisible: false,
                subjectFieldVisible: false,
                creditFieldVisible: false,
                comboData: {
                    standardType: null,
                    stuState: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: null,
                    stuName: null,
                    className: null,
                    stuState: null,
                    mainCode: null,
                    id: null
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                mainTableHeight: 500,
                selectRowData: {},
                operateButtonVisible: false,
                dialogVisible: false,
                formSubmiting: false,
                curdForm: {
                    mainCode: null,
                    year: null,
                    standardType: '',
                    standardRatio: null,
                    id: null,
                },
                graduateRequireDialogVisible: false,
                addStuDialogVisible: false,
                scoreDialogVisible: false,
                scoreTableData: [],
                auditAreaVisible: false,
                loadingMask: null,


                cantGraduateDialogVisible: false,
                cantGraduateTableData: [],
                cantGraduateForm: {
                    stuCode: null,
                    className: null,
                    mainCode: null,
                }
            };
        },
        mounted() {
            this.initData();
            this.initCombo();
            this.queryList();

            this.$nextTick().then(() => {
                this.handleModel();
            });
        },
        methods: {
            //不可毕业学生导出
            cantGraduateExport() {
                this.showLoadingMask("导出中,请稍候...")

                this.$api.student.graduate.cantGraduateExport({
                        responseType: "blob",
                        data: this.cantGraduateForm
                    })
                    .then((res) => {
                        const _this = this;
                        const resultData = res.data;

                        const fileReader = new FileReader();
                        fileReader.onload = function() {
                            if (resultData.type == 'application/json') {
                                const jsonData = JSON.parse(fileReader
                                    .result); // 说明是普通对象数据，后台转换失败
                                showNotify('错误', jsonData.msg, 'error', 3000);
                            } else {
                                const fileName = decodeURI(res.headers['content-disposition']
                                    .split('fileName=')[1]);
                                _this.downloadFileByBlob(resultData, fileName);
                            }
                        };
                        fileReader.readAsText(resultData);

                        this.closeLoadingMask();
                        this.dialogVisible = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.closeLoadingMask();
                        this.dialogVisible = false;
                    });
            },
            exportStuList() {
                this.showLoadingMask("毕/结业学生信息导出中,请稍候...");

                this.$api.student.graduate.exportStuList({
                    responseType: "blob",
                    data: this.queryForm
                }).then((res) => {
                    const _this = this;
                    const resultData = res.data;

                    const fileReader = new FileReader();
                    fileReader.onload = function() {
                        if (resultData.type == 'application/json') {
                            const jsonData = JSON.parse(fileReader
                                .result); // 说明是普通对象数据，后台转换失败
                            showNotify('错误', jsonData.msg, 'error', 3000);
                        } else {
                            const fileName = decodeURI(res.headers['content-disposition']
                                .split('fileName=')[1]);
                            _this.downloadFileByBlob(resultData, fileName);
                        }
                    };
                    fileReader.readAsText(resultData);

                    this.closeLoadingMask();
                    this.dialogVisible = false;
                }).catch((err) => {
                    console.log(err);
                    this.closeLoadingMask();
                    this.dialogVisible = false;
                });
            },
            downloadFileByBlob(data, fileName) {
                let blob = new Blob([data], {
                    type: "application/ms-excel;charset=utf-8"
                });

                //浏览器兼容，Google和火狐支持a标签的download，IE不支持
                if (window.navigator && window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    let url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(url);
                }
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
            //异动信息
            showStatusChange(row) {
                this.$api.student.graduate.statusChange({
                    data: row.stuCode,
                }).then((response) => {
                    this.statusChangeTableData = response.data.data
                }).catch((error) => {
                    console.log(error);
                });

                this.statusChangeDialogVisible = true;
            },
            initData() {
                this.queryForm.mainCode = this.graduateParam.mainCode;
                this.curdForm.mainCode = this.graduateParam.mainCode;
                this.curdForm.year = this.graduateParam.year;
                this.curdForm.standardType = this.graduateParam.standardType;
                this.curdForm.standardRatio = this.graduateParam.standardRatio;
            },
            handleModel() {
                if (this.graduateParam.openType == 'set') {
                    this.operateButtonVisible = true;
                    this.mainTableHeight = 570;
                } else if (this.graduateParam.openType == 'audit') {
                    this.auditAreaVisible = true;
                    this.mainTableHeight = 410;
                } else {
                    this.mainTableHeight = 570;
                }
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                if (this.curdForm.standardType === '02') {
                    this.subjectFieldVisible = false;
                    this.creditFieldVisible = true;
                } else {
                    this.creditFieldVisible = false;
                    this.subjectFieldVisible = true;
                }

                this.$api.student.graduate.graduateStuList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            cantGraduateStu() {
                this.cantGraduateDialogVisible = true;
                this.cantGraduateForm.mainCode = this.queryForm.mainCode
                this.$api.student.graduate.cantGraduateStu({
                    data: this.cantGraduateForm,
                }).then((response) => {
                    this.cantGraduateTableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.stuCode = null;
                // this.queryForm.stuName = null;
                this.queryForm.className = null;
                this.queryForm.stuState = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
                this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            initCombo() {
                this.$api.student.graduate.initGraduateStuCombo({}).then((res) => {
                    this.comboData.standardType = res.data.data.standardType;
                    this.comboData.stuState = res.data.data.stuState;
                }).catch((err) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            initStuRec() {
                if (this.curdForm.standardType == '') {
                    this.curdForm.standardType = '02';
                    this.curdForm.standardRatio = 100;
                }
                this.dialogVisible = true;
            },
            createStuInfo() {
                confirmMsg('为保证毕业学生名单的准确性，请确认学生成绩已录入完毕；如当前学年已有毕业学生名单将会被覆盖，是否继续？').then(() => {
                    this.showMask('毕业学生名单生成中，请稍候...');
                    this.formSubmiting = true;

                    this.$api.student.graduate.create({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;

                        if (state == 'Success') {
                            showNotify('成功', (msg ? msg : '生成成功'), 'success', 1500);
                            this.graduateParam.standardType = this.curdForm.standardType;
                            this.graduateParam.standardRatio = this.curdForm.standardRatio;
                            this.closeDialog();
                        } else {
                            showNotify('失败', (msg ? msg : '生成失败'), 'error', 3000);

                        }
                        this.handleReset();
                        this.updateDialogTitle();
                        this.closeMask();
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                        this.closeMask();
                    });

                    this.formSubmiting = false;
                });
            },
            showGraduateRequire() {
                this.graduateRequireDialogVisible = true;
            },
            showAddStuList() {
                this.addStuDialogVisible = true;
            },
            closeAddStuDialog() {
                this.addStuDialogVisible = false;
                this.queryList();
            },
            showScoreList(rowData) {
                this.queryForm.id = rowData.id;
                this.scoreDialogVisible = true;
                this.queryGraduateScoreList();
            },
            queryGraduateScoreList() {
                this.tableLoading = true;

                this.$api.student.graduate.graduateScoreList({
                    data: this.queryForm,
                }).then((response) => {
                    this.scoreTableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            delStuRec(rowData) {
                confirmMsg('是否确定要从毕业学生名单中删除此学生？').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.student.graduate.delStu({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '删除成功', 'success', 1500);
                            this.currentPage = 1;
                            this.limit = 10;
                            this.queryList();
                        } else {
                            showNotify('失败', '删除失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            delStuRecCantGraduateStu(rowData) {
                confirmMsg('是否确定要从毕业学生名单中删除此学生？').then(() => {
                    this.curdForm.id = rowData.id;
                    this.$api.student.graduate.delStu({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;
                        if (state == 'Success') {
                            showNotify('成功', '删除成功', 'success', 1500);
                            this.cantGraduateStu();
                            this.currentPage = 1;
                            this.limit = 10;
                            this.queryList();
                        } else {
                            showNotify('失败', '删除失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            closeDialog() {
                this.dialogVisible = false;
            },
            submitRec() {
                if (!this.total && this.total < 1) {
                    this.$alert('没有毕业学生名单信息，无需提交！', '提示', {
                        confirmButtonText: '确定'
                    });

                    return;
                }

                confirmMsg('提交后将无法再修改学生信息，是否继续？').then(() => {
                    this.$api.student.graduate.submit({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;

                        if (state == 'Success') {
                            showNotify('成功', (msg ? msg : '保存成功'), 'success', 1500);
                            this.$emit("closeDialog");
                        } else {
                            showNotify('失败', (msg ? msg : '保存失败'), 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            updateDialogTitle() {
                const tempTypeStr = this.curdForm.standardType == '02' ? '学分达标' : '成绩达标';
                const tempRatioStr = this.curdForm.standardType == '02' ? '获得学分' : '合格科目';
                const tempDialogTitle = '毕业学生设置  『 毕业标准：' + tempTypeStr + ' - ' + tempRatioStr + '达到 ' + this.curdForm
                    .standardRatio + ' % 』';
                this.$emit("updateDialogTitle", tempDialogTitle);
            },
            //审核后回调函数
            auditCallback(auditInfo) {
                this.handleAuditEvent(auditInfo);
            },
            //处理审核事件
            handleAuditEvent(auditInfo) {
                this.$api.student.graduate.handleAuditEvent({
                    data: auditInfo,
                }).then((response) => {
                    let state = response.data.data.state;
                    if (state != 'Success') {
                        showNotify('失败', '学生状态更新失败', 'error', 3000);
                    }

                    this.$emit("closeDialog");
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            showMask(msg) {
                this.maskObj = this.$loading({
                    lock: true,
                    text: msg,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            closeMask() {
                this.maskObj.close();
                this.maskObj = null;
            },
            cantGraduateHandleReset() {
                this.cantGraduateForm.stuCode = '';
                this.cantGraduateForm.className = ''
                this.cantGraduateStu()
            }
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// graduateStu.vue?f80754e4